import React from 'react';
import { Box } from '@mui/material';

import Icons from '../../../components/icons';
import MarkBookSectionRow from './MarkBookSectionRow';
import {
  AddMoreButton,
  MarkBookTableHeader,
  MarkBookTableHeaderItem
} from '../styled';
import { MarkBookRowState } from '../hooks/useMarkBookRows';
import { ScoringType } from '../types';

interface MarkBookSectionTableProps {
  firstFieldLabel: string;
  rows: MarkBookRowState[];
  scoringTypeOptions: ScoringType[];
  isLoadingScoringTypes: boolean;
  onUpdateRow: (update: {
    index: number;
    field: keyof MarkBookRowState;
    value: string;
  }) => void;
  onAddRow: () => void;
  onRequestDeleteRow: (index: number) => void;
}

const MarkBookSectionTable: React.FC<MarkBookSectionTableProps> = ({
  firstFieldLabel,
  rows,
  scoringTypeOptions,
  isLoadingScoringTypes,
  onUpdateRow,
  onAddRow,
  onRequestDeleteRow
}) => (
  <>
    <MarkBookTableHeader>
      <MarkBookTableHeaderItem>{firstFieldLabel}</MarkBookTableHeaderItem>
      <MarkBookTableHeaderItem>Scoring Type</MarkBookTableHeaderItem>
      <MarkBookTableHeaderItem>Max Marks</MarkBookTableHeaderItem>
      <MarkBookTableHeaderItem>Order</MarkBookTableHeaderItem>
      <Box sx={{ width: 16, flexShrink: 0 }} />
    </MarkBookTableHeader>
    {rows.map((row, index) => (
      <MarkBookSectionRow
        key={index}
        firstFieldLabel={firstFieldLabel}
        firstFieldValue={row.firstFieldValue}
        scoringTypeValue={row.scoringType}
        maxMarksValue={row.maxMarks}
        orderValue={row.order}
        scoringTypeOptions={scoringTypeOptions}
        isLoadingScoringTypes={isLoadingScoringTypes}
        onFirstFieldChange={(v) =>
          onUpdateRow({ index, field: 'firstFieldValue', value: v })
        }
        onScoringTypeChange={(v) =>
          onUpdateRow({ index, field: 'scoringType', value: v })
        }
        onMaxMarksChange={(v) =>
          onUpdateRow({ index, field: 'maxMarks', value: v })
        }
        onOrderChange={(v) => onUpdateRow({ index, field: 'order', value: v })}
        onDeleteRequest={() => onRequestDeleteRow(index)}
      />
    ))}
    <AddMoreButton onClick={onAddRow}>
      <Icons.PlusPurpleFilled style={{ marginRight: '8px' }} /> Add More
    </AddMoreButton>
  </>
);

export default MarkBookSectionTable;
